export default "__VITE_ASSET__LQyBGZvl__"